// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__nyxwR","main":"Layout_main__FxQfo","footer":"Layout_footer__eJwb-"};